import * as React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { ErrorMessage } from 'formik';

const FormikSelectField = ({
  field,
  form: { touched, errors },
  disabled = false,
  label,
  ...rest
}) => {
  const { id, options, defaultoption, keys } = rest;
  const { name } = field;
  return (
    <FormGroup className="flex-grow-1">
      {label && (
        <Label for={id} className="label-color">
          {label}
        </Label>
      )}
      <Input
        id={id}
        {...field}
        type="select"
        invalid={Boolean(touched[name] && errors[name])}
        disabled={disabled}
        {...rest}
      >
        <option value="">{defaultoption}</option>
        {options.map((option) => {
          if (keys) {
            // eslint-disable-next-line no-shadow
            const { id, label } = keys;
            return (
              <option value={option[id]} key={`${option[id]}_${option[label]}`}>
                {option[label]}
              </option>
            );
          }
          return {
            /* <option>
              
            </option> */
          };
        })}
      </Input>
      <ErrorMessage
        name={name}
        render={(msg) => <div className="text-danger f-14">{msg}</div>}
      />
    </FormGroup>
  );
};

export default FormikSelectField;
